import React, { FC, memo } from 'react'

import { useLocation } from 'react-router-dom'

import { MainSidebar } from '@/components/MainSidebar/MainSidebar'
import { PageContent } from '@/components/PageContent/PageContent'
import { pageTypes } from '@/constants/common'
import { focusIds } from '@/constants/focus'
import { mainPaths } from '@/constants/paths'
import { popupStatus } from '@/constants/popup'
import { PopupBG } from '@/containers/EventDetailPage/styles'
import { TabsPage } from '@/containers/TabsPage/TabsPage'
import { useOpenPrevPagePopup } from '@/hooks/useOpenPrevPagePopup'
import useStore from '@/store/useStore'

const focusId = `${focusIds.PAGE}_${focusIds.POPUP}${focusIds.CONTAINER_MOD}`

const PagePopupRaw: FC = () => {
  const { pathname } = useLocation()
  const { pagePopupStatus } = useStore((state) => state.popup)
  const { pagePopup } = useStore((state) => state.popup)
  const openPrevPagePopup = useOpenPrevPagePopup()

  const isTabPage = pagePopup?.pageType === pageTypes.TABS

  if (
    pagePopupStatus === popupStatus.CLOSED ||
    !mainPaths.some((path) => pathname.includes(path))
  ) {
    return null
  }

  return (
    <PopupBG focusId={focusId} isTrap defaultFocusChild={1}>
      <MainSidebar
        focusIdPrefix={focusId}
        onBack={openPrevPagePopup}
        disableSubMenuAutoOpen
      />
      {isTabPage ? <TabsPage isPopup /> : <PageContent isPopup />}
    </PopupBG>
  )
}

export const PagePopup = memo(PagePopupRaw)
